<div class="h-screen flex relative overflow-hidden">
  <!-- Backdrop mobile -->
  @if (viewportService.isMobile() && isDrawerOpen()) {
    <div class="fixed inset-0 bg-neutral-900 opacity-90 z-10 md:hidden" (click)="toggleDrawer()"></div>
  }

  <app-drawer [isDrawerOpen]="isDrawerOpen()" [isMobile]="viewportService.isMobile()" (toggleDrawer)="toggleDrawer()"></app-drawer>

  <div class="grow flex flex-col min-w-0">
    <app-header [isDrawerOpen]="isDrawerOpen()" (toggleDrawer)="toggleDrawer()"></app-header>
    <main class="overflow-hidden grow">
        <router-outlet></router-outlet>
    </main>
  </div>
</div>
